import React, { Component } from "react";
import Select from "react-select";
import { Image } from "react-bootstrap";
import IconProjects from "../../../assets/frontPageIcons/no-of-project.png";
import CostIcon from "../../../assets/frontPageIcons/cost-project.png";
import { formatNumberOnDashBoard } from "../../../helper";
import { sectorWiseProjects } from "../../../actions/common.action";
import { setSectorDropdownData } from "./sectorWheel.selector";

class SectorResponsive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sectorList: [],
      selectedSector: null
    };
  }

  componentDidMount() {
    this.getSectorWiseData();
  }

  getSectorWiseData = async () => {
    let response = await sectorWiseProjects();
    if (response && response.status) {
      let _data = setSectorDropdownData(response.data.data);
      this.setState(
        {
          sectorList: _data
        },
        () => this.onSectorChanged(_data[0])
      );
    }
  };

  onSectorChanged = obj => {
    this.setState({
      selectedSector: obj
    });
  };

  render() {
    let { sectorList, selectedSector } = this.state;
    return (
      <div className="projects-by-responsive-wrapper" id="projects">
        {sectorList && (
          <Select
            options={sectorList}
            maxMenuHeight={220}
            className="sector-state-selector"
            value={selectedSector}
            onChange={this.onSectorChanged}
          />
        )}
        {selectedSector ? (
          <div className="sector-wise-content-inner sector-wise-responsive">
            <div className="sector-content">
              <div className="stats-wrapper">
                <div className="project-stats">
                  <div className="stats-img">
                    <Image src={IconProjects} alt="Projects" />
                  </div>
                  <div className="sector-stats">
                    <b>{selectedSector.projectCount}</b> Project(s)
                  </div>
                </div>
                <div className="issue-stats">
                  <div className="stats-img">
                    <Image src={CostIcon} alt="Cost" />
                  </div>
                  <div className="sector-stats">
                    <b>
                      {formatNumberOnDashBoard(
                        Number(selectedSector.projectCost.toFixed(1)),
                        true,
                        true,
                        "."
                      )}
                    </b>{" "}
                    Project(s) Investment
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default SectorResponsive;
